import * as z from 'zod';
import type { I18n } from '@lingui/core';
import { formatNumber } from '@worldcoo/ui/lib/utils';
import { DONATION_AMOUNT_LIMIT } from '@worldcoo/shared/core';
import { amountTooHighMessage, errorMessages } from './portal-messages';

/**
 * Amount validation shared by both donation entry points (the campaign donate step and the portal
 * home form), so a donor gets the same message wherever they type the amount.
 *
 * `numberLocale` is separate from the message locale because the campaign decides how amounts are
 * formatted, which is not always the language the portal is being read in.
 */
export function donationAmountSchema(i18n: I18n, numberLocale: string) {
	return z.object({
		amount: z.number().check((ctx) => {
			// A value that is not a number at all already has its own issue, and reporting the amount as
			// too high or too low on top of that would only be noise.
			if (ctx.issues.length > 0) return;
			if (ctx.value >= DONATION_AMOUNT_LIMIT) {
				const max = formatNumber(numberLocale, DONATION_AMOUNT_LIMIT, 0);
				ctx.issues.push({ code: 'custom', message: i18n._(amountTooHighMessage(max)), input: ctx.value });
			} else if (ctx.value <= 0) {
				ctx.issues.push({ code: 'custom', message: i18n._(errorMessages.amount), input: ctx.value });
			}
		}),
	});
}
